import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import { Store } from 'src/store' // Used for JWT

import { site } from '../services/sites'

var baseUrl = process.env.BASE_URL ? process.env.BASE_URL : site.apiBaseUrl

const $axios = axios.create({
  baseURL: baseUrl
})

Vue.prototype.$axios = $axios // attached our constructed axios object to Vue

$axios.interceptors.request.use(config => {
  if (Store.state.user.token) {
    config.headers.Authorization = 'Bearer ' + Store.state.user.token
  }
  return config
})

export default ({ router, store, Vue }) => {
  /*
   * we do this interceptor in this block so we have the router object available
   */
  $axios.interceptors.response.use(res => res, err => {
    if (err.response && err.response.status === 401) { // leave 403 as a legitimate response that doesn't imply the token has expired
      if (_.endsWith(err.config.url, '/api/authenticate')) {
        // a login problem - already logged out
        return Promise.reject(err) // OK to throw 401 back to client here, that's handled in the login page for bad credentials.
      } else {
        // we don't want to have to create a catch on every call to handle the case where the token has timed out.
        return store.dispatch('user/logout').then(() => {
          router.go()
          return Promise.reject(err)
        })
      }
    }
    return Promise.reject(err)
  })
}

export { $axios }
